<div *ngIf="device" class="progress-container-outer mc-card-storage-options">
  <ul class="progress-container list-unstyled system-storage" [ngClass]="device.internalStorageStatus">
    <li>
      <span class="left property-title">{{ 'label_SystemStorage' | xsI18n }}</span>
      <span class="right property-value">{{ device.totalInternalStorage }} </span>
    </li>
    <li class="graph">
      <mat-progress-bar
        [color]="device.usedInternalStoragePercentage > 80 ? 'warn' : ''"
        [value]="device.usedInternalStoragePercentage"
      ></mat-progress-bar>
    </li>
    <li class="property-keys" [hidden]="!device.internalStorageLabel">
      <span class="left property-key">{{ 'label_Used' | xsI18n }}</span>
      <span class="right property-key">{{ 'label_Available' | xsI18n }}</span>
    </li>
    <li class="property-values" [hidden]="!device.internalStorageLabel">
      <span class="left property-value">{{ device.usedInternalStorage }} </span>
      <span class="right property-value">{{ device.availableInternalStorage }} </span>
    </li>
  </ul>
  <ul class="progress-container list-unstyled external-storage" [ngClass]="device.externalStorageStatus">
    <li>
      <span class="left property-title">{{ 'label_ExternalStorage' | xsI18n }}</span>
      <span class="right property-value">{{ device.totalExternalStorage }} </span>
    </li>
    <li class="graph">
      <mat-progress-bar
        [color]="device.usedExternalStoragePercentage > 80 ? 'warn' : ''"
        [value]="device.usedExternalStoragePercentage"
      ></mat-progress-bar>
    </li>
    <li class="property-keys" [hidden]="!device.externalStorageLabel">
      <span class="left property-key">{{ 'label_Used' | xsI18n }}</span>
      <span class="right property-key">{{ 'label_Available' | xsI18n }}</span>
    </li>
    <li class="property-values" [hidden]="!device.externalStorageLabel">
      <span class="left property-value">{{ device.usedExternalStorage }} </span>
      <span class="right property-value">{{ device.availableExternalStorage }} </span>
    </li>
  </ul>
</div>
